<ll-titulo>Revisar simulacros creados</ll-titulo>

<evaluaciones-multiples-compartidas [evaluacionTipo]="tipoInstrumento"></evaluaciones-multiples-compartidas>
<instrumentos-multiples-no-compartidos [evaluacionTipo]="tipoInstrumento"></instrumentos-multiples-no-compartidos>
